/**
 * Stytch TOTP Creation Hook
 *
 * This hook provides functionality for creating TOTP (Time-based One-Time Password)
 * authentication using the Stytch B2B headless client.
 */
import { useCallback } from 'react';
import { getStytchClient } from '../../../../adapters/react/client/headless-client';
export function useStytchTotpCreate() {
    return useCallback(async (data) => {
        const stytch = getStytchClient();
        if (!stytch) {
            return {
                success: false,
                error: 'Stytch client not ready',
                data: null,
            };
        }
        try {
            const result = await stytch.totp.create({
                member_id: data.memberId,
                organization_id: data.organizationId,
                expiration_minutes: data.expirationMinutes || 15,
            });
            return {
                success: true,
                requestId: result.request_id,
                statusCode: result.status_code,
                secret: result.secret,
                //  totpRegistrationId: result.totp_registration_id,
                qrCode: result.qr_code,
                recoveryCodes: result.recovery_codes,
                memberId: result.member_id,
                member: result.member,
                data: result,
            };
        }
        catch (error) {
            const err = error;
            return {
                success: false,
                error: err.error_message || err.message || 'Failed to create TOTP',
                data: error,
            };
        }
    }, []);
}
export function useStytchTotpAuthenticate() {
    return useCallback(async (data) => {
        const stytch = getStytchClient();
        if (!stytch) {
            return {
                success: false,
                error: 'Stytch client not ready',
                data: null,
            };
        }
        try {
            const result = await stytch.totp.authenticate({
                member_id: data.memberId,
                organization_id: data.organizationId,
                code: data.code,
                session_duration_minutes: data.sessionDurationMinutes,
                set_mfa_enrollment: data.setMfaEnrollment,
                set_default_mfa: data.setDefaultMfa,
            });
            return {
                success: true,
                requestId: result.request_id,
                statusCode: result.status_code,
                memberId: result.member_id,
                // organizationId: result.organization_id,
                sessionJwt: result.session_jwt,
                sessionToken: result.session_token,
                memberSession: result.member_session,
                member: result.member,
                organization: result.organization,
                // memberDevice: result.member_device,
                data: result,
            };
        }
        catch (error) {
            const err = error;
            return {
                success: false,
                error: err.error_message || err.message || 'Failed to authenticate TOTP',
                data: error,
            };
        }
    }, []);
}
